"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unchecked = exports.Checked = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Checked = function Checked(props) {
  var theme = (0, _react.useTheme)();
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none"
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("rect", {
      width: 21,
      height: 21,
      rx: 2,
      fill: theme.colors.primary.medium
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M15.2545 6.53684C15.645 6.14631 16.2781 6.14631 16.6687 6.53684C17.0592 6.92736 17.0592 7.56053 16.6687 7.95105L9.24405 15.3757L4.70721 10.8388C4.31669 10.4483 4.31669 9.81515 4.70721 9.42462C5.09774 9.0341 5.7309 9.0341 6.12143 9.42462L9.24405 12.5472L15.2545 6.53684Z",
      fill: "white"
    })]
  }));
}; // eslint-disable-next-line react/prop-types


exports.Checked = Checked;

var Unchecked = function Unchecked(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      props = _objectWithoutProperties(_ref, ["disabled"]);

  var theme = (0, _react.useTheme)();
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none"
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("rect", {
      x: 0.5,
      y: 0.5,
      width: 20,
      height: 20,
      rx: 1.5,
      stroke: disabled ? theme.colors.neutral[200] : theme.colors.neutral[400]
    })
  }));
};

exports.Unchecked = Unchecked;